import { useEffect, useState } from 'react';

import { JaaSMeeting } from '@jitsi/react-sdk';

import JitsiVideoEmbedMobile from './JitsiVideoEmbedMobile';
import * as S from './styles';
import Spin from 'components/Spin';
import { useUser } from 'global/UserContext';
import { useToast } from 'hooks/useToast';
import { MeetingRoom as IMeetingRoom } from 'pages/MeetingRoom/types/meetingTypes';
import { apiMeeting } from 'services/apiService';
import { useIsMobile } from 'utils/mediaQueries';

interface JitsiEmbedProps {
  meetingRoom: IMeetingRoom;
  videoLoading: boolean;
  onLoad: () => void;
  collectionIndex?: number;
  onClose?: () => void;
}

export const JitsiVideoEmbedDirect = ({
  meetingRoom,
  videoLoading,
  onLoad,
  collectionIndex = 0,
  onClose,
}: JitsiEmbedProps) => {
  const isMobile = useIsMobile();
  const { toastError } = useToast();
  const [jitsiAuth, setJitsiAuth] = useState<any>();
  const [error, setError] = useState<boolean>(false);
  const { user } = useUser();

  useEffect(() => {
    getToken();
    // eslint-disable-next-line
  }, []);

  const getToken = async () => {
    try {
      const response = await apiMeeting.get(`/v1/integrations/jitsi/token?user_id=${user?.id}`);
      setJitsiAuth(response?.data ?? '');
      onLoad();
    } catch (error) {
      setError(true);
      toastError('Algo deu errado ao carregar o vídeo');
      console.log('VIDEOCONF', { error });
    }
  };

  if (!meetingRoom || !meetingRoom.room_data) {
    return <div>Dados da sala indisponíveis.</div>;
  }

  if (isMobile) {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <JitsiVideoEmbedMobile meetingRoom={meetingRoom} onClose={onClose} />
      </div>
    );
  }

  if ((videoLoading && !error) || !jitsiAuth) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
        <Spin tip="Loading video..." />
      </div>
    );
  } else if (error || (!videoLoading && !jitsiAuth)) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
        <h1>Erro ao carregar o vídeo</h1>
      </div>
    );
  }
  return (
    <S.VideoContainerDirect>
      <JaaSMeeting
        appId={jitsiAuth?.app_id}
        roomName={meetingRoom.room_data.title}
        jwt={jitsiAuth?.token}
        configOverwrite={{
          disableLocalVideoFlip: true,
          backgroundAlpha: 0,
          defaultLanguage: 'pt-BR',
          toolbarConfig: {
            timeout: 2000,
          },
        }}
        interfaceConfigOverwrite={{
          VIDEO_LAYOUT_FIT: 'nocrop',
          MOBILE_APP_PROMO: false,
          TILE_VIEW_MAX_COLUMNS: 4,
        }}
        userInfo={{
          displayName: `${user?.first_name} ${user?.last_name}`,
          email: user?.email ?? '',
        }}
        spinner={Spin}
        onApiReady={externalApi => {
          console.log({ externalApi });
          onLoad();
        }}
        onReadyToClose={onClose}
      />
    </S.VideoContainerDirect>
  );
};
